function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{opacity:0.45;}.cls-15,.cls-2,.cls-6{mix-blend-mode:multiply;}.cls-3{fill:#ece1df;stroke-miterlimit:10;stroke:url(#Gradient_bez_nazwy_224);}.cls-4{fill:url(#Gradient_bez_nazwy_404);}.cls-5{fill:url(#Gradient_bez_nazwy_391);}.cls-6{opacity:0.8;}.cls-7{fill:#dd2736;}.cls-10,.cls-8{opacity:0.99;}.cls-8{fill:url(#Gradient_bez_nazwy_340);}.cls-9{opacity:0.28;fill:url(#Gradient_bez_nazwy_340-2);}.cls-10{fill:url(#Gradient_bez_nazwy_322);}.cls-11{fill:url(#Gradient_bez_nazwy_351);}.cls-12,.cls-13{opacity:0.31;}.cls-12{fill:url(#Gradient_bez_nazwy_348);}.cls-13{fill:url(#Gradient_bez_nazwy_348-2);}.cls-14{opacity:0.21;}.cls-15{opacity:0.3;}.cls-16{fill:none;stroke:#e8e0dd;stroke-width:3px;}"), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Gradient_bez_nazwy_224",
  x1: 28,
  y1: 1,
  x2: 28,
  y2: 55,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ece1df",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.15,
  stopColor: "#eee5e3",
  stopOpacity: 0.1
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.47,
  stopColor: "#f4eeed",
  stopOpacity: 0.34
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.92,
  stopColor: "#fdfcfc",
  stopOpacity: 0.73
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0.8
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Gradient_bez_nazwy_404",
  cx: 28,
  cy: 28,
  r: 35.08,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.55,
  stopColor: "#ece1df"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.69,
  stopColor: "#ebdedc"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.78,
  stopColor: "#e6d5d3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#dfc5c4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.92,
  stopColor: "#d8b6b6"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Gradient_bez_nazwy_391",
  cx: 28,
  cy: 28,
  r: 35.08,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.57,
  stopColor: "#ece1df",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.62,
  stopColor: "#ebe0de",
  stopOpacity: 0.02
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.65,
  stopColor: "#e9dbd9",
  stopOpacity: 0.07
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.69,
  stopColor: "#e4d3d1",
  stopOpacity: 0.15
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.72,
  stopColor: "#dec8c6",
  stopOpacity: 0.27
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.74,
  stopColor: "#d6b9b8",
  stopOpacity: 0.43
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.77,
  stopColor: "#cca7a6",
  stopOpacity: 0.62
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#c09292",
  stopOpacity: 0.85
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.81,
  stopColor: "#b88484"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Gradient_bez_nazwy_340",
  cx: 28.39,
  cy: 22.41,
  fx: 18.474033993574043,
  r: 23.6,
  gradientTransform: "translate(7.27 50.57) rotate(-89.38) scale(1 0.93)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.62,
  stopColor: "#dd2736",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.75,
  stopColor: "#ab161f",
  stopOpacity: 0.34
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.91,
  stopColor: "#790609",
  stopOpacity: 0.67
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#600",
  stopOpacity: 0.8
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Gradient_bez_nazwy_340-2",
  cx: 28.39,
  cy: 20.06,
  fx: 18.47403399357401,
  r: 23.6,
  gradientTransform: "translate(9.45 48.25) rotate(-89.38) scale(1 0.93)",
  xlinkHref: "#Gradient_bez_nazwy_340"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Gradient_bez_nazwy_322",
  cx: 28.26,
  cy: 22.27,
  fx: 18.894903839471084,
  r: 22.29,
  gradientTransform: "translate(7.26 50.31) rotate(-89.38) scale(1 0.93)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.55,
  stopColor: "#dd2736",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#da2635",
  stopOpacity: 0.02
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#cf2230",
  stopOpacity: 0.1
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.85,
  stopColor: "#bc1c27",
  stopOpacity: 0.22
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopColor: "#a1131b",
  stopOpacity: 0.4
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.94,
  stopColor: "#7e080b",
  stopOpacity: 0.64
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.97,
  stopColor: "#600",
  stopOpacity: 0.8
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Gradient_bez_nazwy_351",
  cx: 28.33,
  cy: 33.86,
  fx: 37.82792001919749,
  r: 22.62,
  gradientTransform: "translate(-4.78 61.82) rotate(-89.38) scale(1 0.97)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.36,
  stopColor: "#dd2736",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.48,
  stopColor: "#dd2a38",
  stopOpacity: 0.01
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.57,
  stopColor: "#df3240",
  stopOpacity: 0.05
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.65,
  stopColor: "#e2404d",
  stopOpacity: 0.11
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.72,
  stopColor: "#e5535f",
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.78,
  stopColor: "#ea6d76",
  stopOpacity: 0.31
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.85,
  stopColor: "#f08c93",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.91,
  stopColor: "#f7b0b4",
  stopOpacity: 0.61
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.96,
  stopColor: "#ffdada",
  stopOpacity: 0.8
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.96,
  stopColor: "#ffdbdb",
  stopOpacity: 0.8
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Gradient_bez_nazwy_348",
  cx: 28.2,
  cy: 33.68,
  fx: 37.31406239694148,
  r: 21.71,
  gradientTransform: "matrix(0.01, -1, 0.94, 0.01, -3.93, 61.53)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.32,
  stopColor: "#dd2736",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.41,
  stopColor: "#de2a39",
  stopOpacity: 0.01
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.49,
  stopColor: "#df3442",
  stopOpacity: 0.06
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.57,
  stopColor: "#e24450",
  stopOpacity: 0.13
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.65,
  stopColor: "#e75b65",
  stopOpacity: 0.23
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  stopColor: "#ec7880",
  stopOpacity: 0.36
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#f39ca1",
  stopOpacity: 0.52
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#fbc5c7",
  stopOpacity: 0.7
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.91,
  stopColor: "#ffdbdb",
  stopOpacity: 0.8
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Gradient_bez_nazwy_348-2",
  cx: 27.94,
  cy: 33.55,
  fx: 37.85602469641495,
  r: 23.61,
  gradientTransform: "matrix(0.01, -1, 1.03, 0.01, -6.79, 61.12)",
  xlinkHref: "#Gradient_bez_nazwy_348"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "cls-1"
}, /*#__PURE__*/React.createElement("g", {
  id: "Warstwa_1",
  "data-name": "Warstwa 1"
}, /*#__PURE__*/React.createElement("image", {
  className: "cls-2",
  width: 57,
  height: 57,
  transform: "translate(-0.5 0.5)",
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADkAAAA5CAYAAACMGIOFAAAACXBIWXMAAAsSAAALEgHS3X78AAACDUlEQVRoQ+2a23HCMBBFL5l80gMFuAeaSAEUkHpSAAWkifRAAfTAP/nAd1hLa72NJeEzw3iG5x7uYgTa3f1+R+98+u6QwB7AYTzGcgNwHY/FKCUpxQ4AvsZjLFcAv3iKFhHeZbYrpQY8xUolSeELMmVTJU25Aelic1D0gkzZFMk9gCOAE5aRM8mWjZGU6Z3wEF1SzkTKngH8IVA09MTz6vQ09rBfO0g0RJKC33h9ehqsh3hFfZK1CZIoUZdkrYIkWHROsnZBwjrlScniQ7sSjw/3GmfQFHhCGjBTqybpfVCFOEPR2jVn7bkWzrY1k2wxRTJbuynZYooStX4p2XKKRHWQkq2nSCwPM8k11qSlsTwo2YsgmfhQspdWJROft0qyazbJXtgke2GT7IVNshc2yV54K8liG56VMPGhpNzh7YGJz1slad3QMJaHlOylZS0PM8nLeGk1TdXB/AppPU21flOy5TRna9cWA1dEDh5UwA2Pes9QulDb1eID+I/XoNynNpzBzC3rWmpbb62utWsLbetsU+IajOATkNq21lnfDzKmP4B6RYMFAb8kUJcol2xRo2chksBU9IZ1Rs/k5y9qiDBmgBCYfq0sNQJqkpSeJFaSvEJWyiWNgJJUSWLKHsR1KcIU4zFLjuRKEinm2tDl7YBeuFxgS+EsSklKXEnyDQD0XzvFxCRLSLrwJbkI/7Xf6KXGEtNSAAAAAElFTkSuQmCC"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-3",
  cx: 28,
  cy: 28,
  r: 26.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-4",
  cx: 28,
  cy: 28,
  r: 26.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-5",
  cx: 28,
  cy: 28,
  r: 26.5
}), /*#__PURE__*/React.createElement("image", {
  className: "cls-6",
  width: 43,
  height: 43,
  transform: "translate(6.5 8.5)",
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAArCAYAAADhXXHAAAAACXBIWXMAAAsSAAALEgHS3X78AAAD+UlEQVRYR92Za08TURCGn16wFZB7uGpASWqMX/xX/Cb+lV+MCQkKAaoShLZgaUtL/fCe6Z5ud1t6WUx9k00X3e68886cOTOnqXa7zbQgO+iBfjg9PEy5W/vshzbA7sHByOqkRlHWkUy7K+M+U0STbrvrEWi5z8dRSA9F1iOZBV4AOeClu88ST7YJNIB7oO7umwxJ+klkPZIZRHAWWACWgRVgDhE2hQ2maAP4A1wDN0AFqCLiLZ5IeiBZRzSDyMwBS8AasO1dy0DePRdGC6ghkkXvugJKyIkG0BpEOJasI5lC4c0Di8A68AbYBfaAHWADeIUUT0e86hEpeAv8Ai6AE+AUOAMugTJyqAm040j3qwYpYAapuYqI7QMF4K37ew2lQ47BOVsHNt33dlBEVoFj5MBvpPKD+04PIpV1qs4A80i5d4jkB0R4C+XqLEoPqwhxsErQQLl6DfxARL8CR8A3pPwd8BClbg9ZL0fnUNgLwCfgIyK6iVIij9QML6o42GJropCXgZ+I8BfgMyJ9iRTuyeGoNEgjtRZQuAqI6HukqIU9w9NIGkwEqypZFD3jUEUkaygVrFJ00BW6CFX36Q79EsGqH4aoD7ORR+/botvOOrKf8XZIoFfZNFJtCa36AkHoF4iupaPA6rZFcBPl6g1aaBWkcAtP3Y6yzossWjRrBOVpC+WolaZxiRqMcA69fwvZ20X2Z4Gsr66fBubpIiore8BrtOrHDX0c/JRYQfb2kP1FgkiC3XjbqaXANlpcqzgPmTxRgx9Rq+fbiEcOSJu6vrIZ1JSsuIc3iPAuIfhR3UD2VxCfzhZuJHxl59Feb1toEuEPw9Ihh+wuIx5d6yScs9aw5Am20KRVNVjrmUP2e3bGMBFT2K6kFQ2jr/041Z6bZBiR9p8rxBPBf0F24IiRMCLth8laG2fXc5Pua98n6zfINdSiNd2/Pwes160j+w2C0R0IyJpHdYLu55agp0xa4TayY7PaDeJRx1PYV7aF5vprNH3+Qt18g+TVtXG9jOwWEY97wi2iGx9M2ZJ72Ia4Km7qJBnYQFlF9i6Q/RJOWRtvwjlr3hXRuHyOPLRGeNKELfw1ZOcc2S0SEdUOWcfePLxCc/0JmkLLhPJnAvCjWUZ2TpDdK1xE/aExPNb4qXCG+kvrgGYIWrlx+wYj2kAjjE25R8huJwX8L3XVWedFC02ZlwRz/THyvMT4KeGHvkT3+cExQ47ivscXaNKcdf/XJLlzgyNkr0JMBZruExnD6eFhmsmfdVXQ4rkAviOSPWdduwcHkXW938FcG52M3BGE7ha9tIim0EROESPeAfRR1jAV57M+pubk28dU/KYQxlT8WhPGVPwO9q/wFxZD51pAtBL7AAAAAElFTkSuQmCC"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-7",
  cx: 28,
  cy: 28,
  r: 16.31
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-8",
  cx: 28,
  cy: 28,
  r: 16.31
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-9",
  cx: 28,
  cy: 28,
  r: 16.31
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-10",
  cx: 28,
  cy: 28,
  r: 16.31
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-11",
  cx: 28,
  cy: 28,
  r: 16.31
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-12",
  cx: 28,
  cy: 28,
  r: 16.31
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-13",
  cx: 28,
  cy: 28,
  r: 16.31
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-14"
}, /*#__PURE__*/React.createElement("image", {
  width: 83,
  height: 88,
  transform: "translate(-16 -16)",
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFMAAABYCAYAAACJdcvDAAAACXBIWXMAAAsSAAALEgHS3X78AAADvElEQVR4Xu3aTU8bVxSA4ffcGWzACh8FqQWM8MJBlCqoKit+SH4lP4RVKjWt1ChxFFNMEVH4TBwYe+aeLgxSSBd0cVpfV+eRvLFGo5lX986d8VhUFWcjPLaB++c8piGPachjGvKYhjymIY9pyGMa8piGPKYhj2nIYxrymIY8piGPachjGvKYhjymIY9pyGMa8piGPKYhj2nIYxrymIY8piGPachjGvKYhjymIY9paOJiyp3HthuHSYopsJ+paqaqGexno+/SIRPyz+EA5J1OZ7rRaNTgI1NT3xTL798XbG+XQHxsB/+FSYgZut1ubaaq5mKeL2WwAEPKmJ1rUXxYi/Ej29tDYOwnkj+2wZiFXu+g3mBlvqrJeojVU5A11VCKxHe1ev33D0+eDJahYvQZq5Rjhl7voF4vV+YjbEgZnxFkB1gV5FPIIMbqtBqen8HyDaPr51hHZ6oxH4REqx3Jwk+qbKrqrArHRM2FtFb1FFfzv4VE2FWVLUUXEfksyJ+CHGfkF/1+GDAakWMdlZBezNDtdmsPQ8quwpbAvBCuRHhNrF5q4E1ZlmftdvuWRFbzlKa5APlMVc1VNVmXKM8kyC7I9ygLCJfE+FqFn5H816ziqJ9xDZQkMCohrZEZOp3OdJ7nSxJ5quiPKD/EqN/JKNihiPwiqr9lcvNHkZ9ctVqtAYmMSkgnpgDSaMRaRbmowrogGwjfCtQR+ooeRziM9fykmh5eNw96AxFJYkTeSyXm/0IqMRXQfj8MMvILUY4UPUQ5VShQGoKsBdgIRbmS3U7N9faaNVVN6tYopQUottvt29O3b8+0Jm8kyiyieRCJqrogsKGqNwQZVnEm1ssZ7Xa7lyldN1OKqUB5k2XXjYqjCEFjFAQU3RJkDgmbgkbVUqs8xJmBRuASSOLZPJVpfi+2Wq1BkZ9cBThEspeovhB4pXClxHlVNgnZjkSe5nm+1Ol0pknkPJI4iK/EZnOveBiUFyL6SpALVGcVXVV0raJcbDRijbu7gcd2/G9LaZp/KTabe0Wvd3BVL1cOo2RoVSpBhiKyKiqfNKMkxrFP7S+lGhO+ClrlIUrkM8iaomWs9N2UZudhaqEgkWdz/3HY0CTEBH9tYU5gP8Dzu4VmX+F5JIEReW+SYgKjV70AmuCBT1zMlKV4nzmxPKYhj2nIYxrymIY8piGPachjGvKYhjymIY9pyGMa8piGPKYhj2nIYxrymIY8piGPachjGvKYhjymIY9pyGMa8piGPKYhj2nIYxrymIY8piGPaegvmMCgGuc5HRcAAAAASUVORK5CYII="
})), /*#__PURE__*/React.createElement("image", {
  className: "cls-15",
  width: 21,
  height: 26,
  transform: "translate(18.5 15.5)",
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAaCAYAAABYQRdDAAAACXBIWXMAAAsSAAALEgHS3X78AAAB80lEQVRIS7XVeU/UUBTG4afDIrhABGJiXECiUaN8mfmg822MMTFRXGJUVgFl61z/OLdMW2eYIcGTNE3b21/f+56lRUrJdcf0uAXt6BZFUb/uDVFVTKo0wwp08gH9fKQ6fCJoBk5hBnOYzY9OcIwz9Cvw2O3XgHNYwFI+J+xhG79wmu9drrQFXMIDrOGeUPcZ7/ENhyh7KaWRSocAH+MlnmMFB3npFnbwGyUjtj8EuCqAG0Jp5emMSF4jOlqRgdOY11S4gXUsCv+28MPAz37FaCjtFkUn36sUPsrA10LhbbHtD3iHj2Lrx4Zlv7bleSxn4Au8ysCb2M/AN3iLr0LpmZz5BlRYMSPU3MezDFzHrQzcrAE/Gags68XfodEt0xmwgoeihO7mtdsZuilKaF8Uf9lu1Q4X/ZuE2efC+PN8Pb7lWlHPfhLeHOKnKOwv2M3Pl0VprQp7FnEDU+0hU/c0CXVH+J5fmBUfXsMdPGmtJ/vaLYryn+z3UkrdougLn3aFx3UFVY0+zfeT6KDzfL6wqlGnGVyKjO7UHlUjb91A8amw6gB/cNYtijS090eA64rXhC0rYrAsiBx0XNb7I8BVhZwYDJRG0VcxckqNAJdiy/XRtyc+dNH7Yyf/VYZ0L6U+E0C5+u9kIij/4cdXj2v9RV8l/gJjOfIeJAyyNgAAAABJRU5ErkJggg=="
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-16",
  d: "M31.57,21.38,24.43,28l7,6.66"
})));

function SvgArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/ArrowLeft.c1e504fe.svg";
export { ForwardRef as ReactComponent };